import './radio.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

const Checkbox = props => {
	const radioId = `${props.input.name}-${props.defaultValue}`;
	const isChecked = props.defaultValue == props.input.value;
	return (
		<div className="form-element-radio">
			<div className={cn({
				'radio': true,
				'is-disabled': props.disabled
			})}>
				<input
					type="radio"
					id={radioId}
					checked={isChecked}
					disabled={props.disabled}
					{...props.input}
					onChange={() => {
						props.input.onChange(props.defaultValue);
					} } />
				<label htmlFor={radioId}/>
			</div>
			{ props.labelText && (
				<label htmlFor={radioId} className="label-name">
					{props.labelText}
				</label>
			) }
		</div>
	);
};

Checkbox.propTypes = {
	input: PropTypes.object,
	defaultValue: PropTypes.string,
	labelText: PropTypes.string,
	disabled: PropTypes.bool
};

export default Checkbox;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/radio.js